import { useTranslate } from "@tolgee/react";
import { cn } from "#/lib/utils";
import {
	type OrderType,
	orderTypeOptions,
} from "../order-form/constants/order-form.constants.ts";
import { TradePopoverSelect } from "../trade-popover-select.tsx";

type MobileOrderTypeTabsProps = {
	value: OrderType;
	onValueChange: (type: OrderType) => void;
};

const triggerClassName = cn(
	"h-5.5 w-full justify-center gap-1 border-0 bg-transparent px-0 py-0",
	"text-caption1-medium text-trade-text-strong shadow-none",
	"hover:border-transparent hover:bg-transparent",
	"[&_[data-slot=select-value]]:min-w-0 [&_[data-slot=select-value]]:truncate",
	"[&_[data-slot=popover-trigger-icon]]:size-3 [&_[data-slot=popover-trigger-icon]]:text-trade-text-secondary",
);

export function MobileOrderTypeTabs({
	value,
	onValueChange,
}: MobileOrderTypeTabsProps) {
	const { t } = useTranslate();
	const options = orderTypeOptions.map((option) => ({
		value: option.value,
		label: t(option.labelKey),
	}));

	return (
		<TradePopoverSelect
			ariaLabel="Order type"
			align="start"
			contentClassName="min-w-32 rounded-md [&_[data-slot=select-viewport]]:p-1"
			itemClassName="justify-start rounded px-2.5 py-1.5 text-label2-bold"
			onValueChange={onValueChange}
			options={options}
			sideOffset={4}
			triggerClassName={triggerClassName}
			value={value}
		/>
	);
}
